'use es6';

import { OBSIDIAN } from 'HubStyleTokens/colors';
import styled from 'styled-components';
const Subtext = styled.span.withConfig({
  displayName: "Subtext",
  componentId: "ysisum-0"
})(["font-size:12px;line-height:20px;color:", ";"], OBSIDIAN);
export default Subtext;